import { ChannelsConfig } from "../../ChannelsConfig";
import { STR_ERRORS } from "../../strings";
export function getChannelData(connName, message) {
    const connectionChannels = ChannelsConfig[connName];
    if (typeof connectionChannels === "undefined") {
        throw new Error(STR_ERRORS.NoChannelMappingForConnection);
    }
    const channel = connectionChannels[message.name];
    if (typeof channel === "undefined") {
        throw new Error(STR_ERRORS.NoChannel);
    }
    else if (typeof channel.path === "function") {
        return Object.assign(Object.assign({}, channel.path(message.params)), { method: getMethod(channel.method), meta: message.meta });
    }
    return {
        channel: channel.path,
        method: getMethod(channel.method),
        params: message.params,
        meta: message.meta
    };
}
function getMethod(method = "GET") {
    return method;
}
//# sourceMappingURL=getChannelData.js.map